import React from 'react';
import PropTypes from 'prop-types';
import {
  Col,
  FormGroup,
  FormFeedback,
  Label,
  Input,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import AdminEditButtons from '../EditButtons';
import ErrorBoundary from '../../ErrorBoundary';
import { getSetting } from '../../../helpers/Settings';

const AdminTaxonomyEditMainEdit = ({
  taxonomy,
  taxonomyId,
  errors,
  saving,
  handleChange,
  handleSave,
  handleDelete,
}) => {
  const intl = useIntl();

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSave();
    }
  };

  return (
    <ErrorBoundary>
      <div className="tab-content-wrapper">
        <div className="custom-category-profile">
          <div className="custom-category-details">
            <FormGroup row>
              <Col sm="6">
                <Label for="inpCategoryName">
                  {intl.formatMessage({ defaultMessage: 'Name' })}
                </Label>
                <Input
                  type="text"
                  name="name"
                  id="inpCategoryName"
                  placeholder={intl.formatMessage({ defaultMessage: 'Tag Category name' })}
                  value={taxonomy.name || ''}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                  invalid={errors.includes('name')}
                  autoFocus={!taxonomyId}
                />
                {errors.includes('name') && (
                  <FormFeedback>
                    {intl.formatMessage({ defaultMessage: 'This field is required' })}
                  </FormFeedback>
                )}
              </Col>
              <Col sm="6">
                <Label for="inpCategoryNamePlural">
                  {intl.formatMessage({ defaultMessage: 'Plural name' })}
                </Label>
                <Input
                  type="text"
                  name="plural"
                  id="inpCategoryNamePlural"
                  placeholder={intl.formatMessage({ defaultMessage: 'Tag Category plural name' })}
                  value={taxonomy.plural || ''}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                  invalid={errors.includes('plural')}
                />
                {errors.includes('plural') && (
                  <FormFeedback>
                    {intl.formatMessage({ defaultMessage: 'This field is required' })}
                  </FormFeedback>
                )}
              </Col>
            </FormGroup>
            {!taxonomy.ai_tagging && (
              <FormGroup>
                <Label for="taxonomy_required" className="switch">
                  <div className="switch-control input-inner">
                    <Input
                      type="checkbox"
                      id="taxonomy_required"
                      name="taxonomy_required"
                      defaultChecked={taxonomy.required}
                      value={true}
                      onChange={handleChange}
                    />
                    <i />
                  </div>
                  <div className="switch-details">
                    <span>{intl.formatMessage({ defaultMessage: 'Required' })}</span>
                  </div>
                </Label>
              </FormGroup>
            )}
            {getSetting('exif_mapping_enabled') && (
              <FormGroup>
                <Label for="mapping" className="switch">
                  <div className="switch-control input-inner">
                    <Input
                      type="checkbox"
                      id="mapping"
                      name="mapping"
                      defaultChecked={taxonomy.mapping}
                      value={true}
                      onChange={handleChange}
                    />
                    <i />
                  </div>
                  <div className="switch-details">
                    <span>{intl.formatMessage({ defaultMessage: 'Enable automatic mapping' })}</span>
                  </div>
                </Label>
              </FormGroup>
            )}
            <FormGroup>
              <Label for="show_on_shares" className="switch">
                <div className="switch-control input-inner">
                  <Input
                    type="checkbox"
                    id="show_on_shares"
                    name="show_on_shares"
                    defaultChecked={taxonomy.show_on_shares}
                    value={true}
                    onChange={handleChange}
                  />
                  <i />
                </div>
                <div className="switch-details">
                  <span>{intl.formatMessage({ defaultMessage: 'Show tags on share pages' })}</span>
                </div>
              </Label>
            </FormGroup>
          </div>
        </div>
      </div>
      <AdminEditButtons
        handleSave={handleSave}
        saving={saving}
        deleteText={intl.formatMessage({ defaultMessage: 'Delete Tag Category' })}
        hideDelete={taxonomyId === null}
        handleDelete={handleDelete}
      />
    </ErrorBoundary>
  );
};

AdminTaxonomyEditMainEdit.propTypes = {
  taxonomy: PropTypes.object,
  taxonomyId: PropTypes.string,
  errors: PropTypes.array.isRequired,
  saving: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
};

AdminTaxonomyEditMainEdit.defaultProps = {
  taxonomy: null,
  taxonomyId: null,
};

export default AdminTaxonomyEditMainEdit;
